//@flow
import BaseStore from './immutableStoreClass';
import type { Error, StoreState } from './immutableStoreClass';
import type { Store } from 'flux/utils';

export type HandlerFunction = (store:$Subtype<BaseStore>, data:any, action?:string, error?:?Error) => any;

//Can set type as BaseStore since all stores inherit from it
export type HandlerAdd = (action:string, handler:HandlerFunction|HandlerFunction[], waitFor?:Store[]) => void;

export type { Error, StoreState };

type HandlerType = 'success'|'error';
type HandlerData = { [HandlerType]:{ [string]:{ handler:HandlerFunction[], waitFor:Store[] } }};

const _dispatchHandlers:WeakMap<Object, HandlerData> = new WeakMap();

function _addDispatchHandler(type:HandlerType, action:string, handler:Function|Function[], waitFor:Store[] = []) {
  const handlers = _dispatchHandlers.get(this) || {};
  handlers[type] = handlers[type] || {};
  const handlerData = handlers[type][action] || { handler: [], waitFor: []};
  handlerData.handler = handlerData.handler.concat(handler);
  handlerData.waitFor = handlerData.waitFor.concat(waitFor);

  handlers[type][action] = handlerData;
  _dispatchHandlers.set(this, handlers);
}

function _getDispatchHandlers(store:Store, type:HandlerType) {
  const handlers = _dispatchHandlers.get(store) || {};
  return handlers[type] || {};
}

export default class FunctionStore extends BaseStore {
  stores:{ [string]:$Subtype<BaseStore> };

  constructor(initialData?:Object = {}, stores?:{ [string]:$Subtype<BaseStore> }) {
    super(initialData);
    this.stores = stores || {};
    const onSuccess = _addDispatchHandler.bind(this, 'success');
    const onError = _addDispatchHandler.bind(this, 'error');
    this._setup(onSuccess, onError);
  }

  +_setup:(onSuccess:HandlerAdd, onError:HandlerAdd) => void;

  __onDispatchSuccess(action:string, data:any) {
    const handlers = _getDispatchHandlers(this, 'success');
    const handlerObj = handlers[action];
    if (!handlerObj) return;

    if (handlerObj.waitFor && handlerObj.waitFor.length > 0) {
      const tokens = handlerObj.waitFor.map((store) => store.getDispatchToken());
      this.getDispatcher().waitFor(tokens);
    }

    handlerObj.handler.forEach((handler) => {
      handler.call(this, this, data, action);
    });
  }

  __onDispatchError(action:string, error:?Error, data:any) {
    const handlers = _getDispatchHandlers(this, 'error');
    const handlerObj = handlers[action] || (error && handlers[error.type]);
    if (!handlerObj) return;

    handlerObj.handler.forEach((handler) => {
      handler.call(this, this, data, action, error);
    });
  }
}
